module.exports = __webpack_public_path__ + "img/people.3b0fbfab.png";